<template>
  <div class="flex flex-col min-h-screen">
    <nav class="flex-shrink bg-white main-container">
      <!-- Primary Navigation Menu -->
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-end py-3">
          <div v-if="showLocaleSwitcher" class="language-container flex items-center">
            <span v-for="locale in locales" :key="locale.slug">
              <a
                rel="alternate"
                :hreflang="locale.slug"
                :href="locale.url"
                :class="[isActive(locale.url) ? 'active' : '']"
                >{{ locale.slug.toUpperCase() }}</a
              >
            </span>
          </div>
        </div>
        <div class="flex justify-between mb-4">
          <div class="flex w-full justify-between">
            <!-- Logo -->
            <div class="shrink-0 flex items-center">
              <WebLogo class="block h-9 w-auto" />
            </div>
            <!--div class="text-center">
              <a :href="`${whastapp}`" target="_blank" class="flex justify-between">
                <WebWhatsappIcon class="block h-9 w-auto" />
                <p class="phone block text-alo-600 font-medium">{{ phone }}</p>
              </a>
              <p class="schedule text-alo-600 font-normal">Atención al cliente: L-V de 9 a 17h</p>
            </div-->
          </div>
        </div>
      </div>
    </nav>

    <!-- Page Content -->
    <div class="flex-grow pb-12">
      <main class="max-w-7xl mx-auto main-container">
        <slot />
      </main>
    </div>
  </div>
</template>

<script>
import WebLogo from '@/Web/Components/WebLogo.vue'
//import WebWhatsappIcon from '@/Web/Components/WebWhatsappIcon.vue'

export default {
  components: {
    WebLogo,
    //WebWhatsappIcon,
  },

  props: {
    phone: {
      type: String,
      default: '919 700 700',
    },
    whastapp: {
      type: String,
      default: 'https://api.whatsapp.com/send?phone=34919700700',
    },
    showLocaleSwitcher: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    const locales = this.getLocalesArray()

    return {
      locales: locales,
      currentLocale: '',
    }
  },

  created() {
    let splittedUrl = this.$page.url.split('/')
    this.currentLocale = splittedUrl[1]
  },

  methods: {
    getLocalesArray() {
      return [
        {
          slug: 'es',
          url: this.getLocalizedUrl('es'),
        },
        {
          slug: 'en',
          url: this.getLocalizedUrl('en'),
        },
        {
          slug: 'de',
          url: this.getLocalizedUrl('de'),
        },
      ]
    },
    getLocalizedUrl(locale) {
      let splittedUrl = this.$page.url.split('/')
      splittedUrl[1] = locale
      return splittedUrl.join('/')
    },
    isActive(url) {
      return url === this.$page.url
    },
  },
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Ubuntu:wght@400;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Prompt:wght@300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap');

.content {
  min-height: calc(100vh - 300px);
}

.language-container a {
  color: #50576a;
}

.language-container a.active {
  text-decoration: underline;
  font-weight: bolder;
}

.language-container span:after {
  display: inline-block;
  content: '/';
  margin: 0 0.5rem;
}

.language-container span:last-child:after {
  content: '';
}

.phone {
  font-family: 'Poppins', sans-serif;
  font-size: 32px;
  line-height: 1;
}

.schedule {
  font-family: 'Poppins', sans-serif;
  line-height: 21px;
  font-size: 14px;
}

footer {
  background-color: #50576a;
  height: fit-content;
  min-height: 500px;
}

footer ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

footer ul li {
  color: white;
  font-family: 'Prompt', sans-serif;
}

footer ul .title {
  color: #aeca26;
  font-family: 'Ubuntu', sans-serif;
  font-size: 22px;
}

.social-icons img {
  filter: drop-shadow(6px 6px 4px #333844);
  transition: brightness 0.3s;
}

// @media screen and (max-width: 1440px) {
//   .phone {
//     font-size: 45px;
//   }

//   .schedule {
//     font-size: 13px;
//   }
// }

@media screen and (max-width: 450px) {
  .phone {
    font-size: 23px;
  }

  .schedule {
    font-size: 10.2px;
    line-height: 15.3px;
  }

  footer ul .title {
    font-size: 17px;
  }
}
</style>
